module.exports = __webpack_public_path__ + "static/media/Courgette-Regular.909ea532.ttf";